export default __webpack_public_path__ + "static/media/jcb.7d0ee19b.svg";